import { useState, useEffect } from 'react';
import { getScreenSize } from '../styles/responsive';

export function useResponsive() {
  const [screen, setScreen] = useState(getScreenSize());

  useEffect(() => {
    const handleResize = () => setScreen(getScreenSize());
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return screen;
}

// Backward compatibility
export function useIsMobile() {
  const screen = useResponsive();
  return { isMobile: screen.isMobile, isTablet: screen.isTablet };
}